import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { RowComponent } from './components/row/row.component';
import { ColComponent } from './components/col/col.component';
import { ContainerComponent } from './components/container/container.component';
import { SpacerComponent } from './components/spacer/spacer.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    RowComponent,
    ColComponent,
    ContainerComponent,
    SpacerComponent
  ],
  exports: [
    RowComponent,
    ColComponent,
    ContainerComponent,
    SpacerComponent
  ]
})
export class McRAIGridModule { }
